import { AxiosError } from 'axios'
import { ApiClient } from '@/services/Http'

export const getUserData = async () => {
  try {
    const instance = await ApiClient(true)
    const response = await instance.get('me')
    return response ? response.data : null
  } catch (e) {
    const error = e as AxiosError
    const message = error.message || 'ERROR_GENERIC'
    throw new Error(message)
  }
}
